import React from "react";
import { MapPinned } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 6 (Family F) — Field, Facility, Laboratory & Technical Operations
const FieldInfrastructure = () => (
  <SolutionPageLayout
    testId="page-solution-field-infrastructure"
    icon={MapPinned}
    overline="Pathway · 06 of 07 · Aligned with Family F"
    title="For Field, Facility, Laboratory & Technical Operations"
    headline="Field teams, facilities, infrastructure, technical tasks, laboratories, sample processes, maintenance, inspections, spatial records, mobile work orders, and service execution outside the central office."
    intro={[
      "For institutions that manage field teams, facilities, infrastructure, technical tasks, laboratories, sample processes, maintenance, inspections, spatial records, mobile work orders, and service execution outside the central office.",
      "This pathway is relevant for municipalities, industrial zones, utility operators, campuses, hospitals, clinics, laboratories, large facilities, technical service units, and regulated operating environments.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Zoning, licensing, and address numbering processes",
      "Real estate, immovable property, and spatial records",
      "Land registry, cadastre, and GIS readiness where local infrastructure allows",
      "Fault, incident, maintenance, and repair workflows",
      "Mobile work orders and field task execution",
      "Facility and technical service coordination",
      "Laboratory sample workflows",
      "Sample collection task forms",
      "Vehicle-linked field activity coordination where relevant",
      "Analysis type, technique, category, and pricing parameters",
      "Laboratory reporting, quality control, and archive continuity",
      "Wastewater discharge and analysis management",
    ]}
    ctaTitle="Connect field, facility, and laboratory operations with stronger institutional visibility."
    primaryCta={{ label: "Discuss Field & Laboratory Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#field-infrastructure-spatial-operations" }}
  />
);

export default FieldInfrastructure;
